export const TAB_IDS = {
  InterviewDetails: 'interview-details',
  PreparationCall: 'preparation-call',
  DebriefingCall: 'debriefing-call'
};

export const INTERVIEW_DRAWER_MODES = {
  View: 'view',
  Edit: 'edit'
};
